import SisuFunnelBannerContainer from './SisuFunnelBanner.container';
import SisuFunnelBanner from './SisuFunnelBanner';
export default SisuFunnelBannerContainer(SisuFunnelBanner);

//# sourceMappingURL=index.js.map